import { Component, inject } from "@angular/core";
import { ObservabilityService } from "@app/shared/services/observability.service";

// Navbar plugin: the "report a bug" trigger for Sentry's User Feedback widget. Rendered
// only when bug reporting is enabled for the user (guarded in the template); all Sentry
// logic lives in the injected service, this component is just its presentation in the top bar.
@Component({
    selector: "app-navbar-bug-report",
    templateUrl: "./navbar-bug-report.component.html",
    styleUrls: ["../navbar-plugin-base.scss"],
})
export class NavbarBugReportComponent {
    protected readonly observability = inject(ObservabilityService);
}
